import React from "react";
import {GlobalAlertContextConsumer} from "./GlobalAlertContextProvider";
import AlertBadge from "./AlertBadge";

class ItemAlertBadge extends React.Component<any, any> {
  public render() {
    return (
      <GlobalAlertContextConsumer>
        {(globalAlertContextState) => {
          return (
            <AlertBadge count={globalAlertContextState.item.alertCount} />
          );
        }}
      </GlobalAlertContextConsumer>
    );
  }
}

export default ItemAlertBadge;


// WEBPACK FOOTER //
// ./src/app/alert/ItemAlertBadge.tsx